import './StoresList.scss';
import { Store } from '../../types/Store';
import { useState } from 'react';
import { addStore } from '../../services/storesList';
import { useNavigate } from 'react-router-dom';

interface StoresListProps {
  stores: Store[];
  onStoreAdded: () => void; // Function to refresh store list after adding a store
}

export const StoresList: React.FC<StoresListProps> = ({ stores, onStoreAdded }) => {
  // temporary bug fix for esl issues
  // localStorage.setItem('storeId', "1878283030729068544");
  // localStorage.setItem('storeName', "Taipei101");

  const [isAddingStore, setIsAddingStore] = useState(false);
  const [newStore, setNewStore] = useState({
    number: '',
    name: '',
    address: '',
  });
  const token = "eyJhbGciOiJIUzI1NiIsImtpZCI6Im1RdkNWNVVkZmxkRzhaOWQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL3d2c3V0c2ZoY3J4Zm9seHpheHZyLnN1cGFiYXNlLmNvL2F1dGgvdjEiLCJzdWIiOiIxY2M2MGYzOC03ZTlkLTRiMDYtODNhOC0xNDkwOGM2MWIyM2EiLCJhdWQiOiJhdXRoZW50aWNhdGVkIiwiZXhwIjoxNzQ0MDA4ODAzLCJpYXQiOjE3NDQwMDUyMDMsImVtYWlsIjoiYW5kcml5Lm15c2hlbml1a0BnbWFpbC5jb20iLCJwaG9uZSI6IiIsImFwcF9tZXRhZGF0YSI6eyJwcm92aWRlciI6ImVtYWlsIiwicHJvdmlkZXJzIjpbImVtYWlsIl19LCJ1c2VyX21ldGFkYXRhIjp7ImVtYWlsX3ZlcmlmaWVkIjp0cnVlfSwicm9sZSI6ImF1dGhlbnRpY2F0ZWQiLCJhYWwiOiJhYWwxIiwiYW1yIjpbeyJtZXRob2QiOiJwYXNzd29yZCIsInRpbWVzdGFtcCI6MTc0NDAwNTIwM31dLCJzZXNzaW9uX2lkIjoiMTJlN2FkOTYtNWEwZC00ODA0LWI4MTItMWZmNmU0YzQ5NjljIiwiaXNfYW5vbnltb3VzIjpmYWxzZX0.m8pSX3diGebx17GLATN8UjjsuzWwK9uWdT8YKmcyCEM";
  const navigate = useNavigate();

  console.log(stores);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewStore({ ...newStore, [e.target.name]: e.target.value });
  };

  const handleAddStoreSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) {
      alert('Token is not available. Please log in again.');
      return;
    }

    setIsAddingStore(true);
    try {
      const response = await addStore(newStore);
      if (response) {
        alert('Store added successfully!');
        setNewStore({ number: '', name: '', address: '' }); // Reset form
        onStoreAdded(); // Refresh store list
        setIsAddingStore(false);
      } else {
        alert(`Failed to add store: ${response.message || 'Unknown error'}`);
        setIsAddingStore(false);
      }
    } catch (error) {
      console.error('Error adding store:', error);
      alert('Failed to add store. Please check console for details.');
      setIsAddingStore(false);
    }
  };

  const handleStoreClick = (store: Store | null) => {
	if(store){
		localStorage.setItem('storeId', store.id || "");
		localStorage.setItem('storeName', store.name || "");
	}
    else{
		localStorage.setItem('storeId', "1878283030729068544");
		localStorage.setItem('storeName', "Taipei101");
		alert('store not found, using static storeID:1878283030729068544');
	}
	navigate('/displays');
  };

  return (
    <div className="store-list">
      <div className="store-list__container">
        <div className="store-list__header">
          <h1 className="store-list__title">Hi, User!</h1>
          <button
            className="store-list__button"
            onClick={() => setIsAddingStore(true)}
            disabled={isAddingStore}
          >
            + Create New Space
          </button>
        </div>

        <div className="store-list__grid">
          {stores.map((store) => (
            <div key={store.id} className="store-list__card" onClick={() => handleStoreClick(store)}>
              <span className="store-list__icon">💛</span>
              <div className="store-list__info">
                <h2 className="store-list__name">{store.name}</h2>
                <p className="store-list__subhead">{store.address}</p>
              </div>
            </div>
          ))}

          {/* <div key="1878283030729068544" className="store-list__card" onClick={() => handleStoreClick(null)}>
              <span className="store-list__icon">💛</span>
              <div className="store-list__info">
                <h2 className="store-list__name">Taipei101</h2>
                <p className="store-list__subhead">111 Sugondese</p>
              </div>
            </div> */}
        </div>

        {isAddingStore && (
          <div className="add-store-form-overlay">
            <form className="add-store-form" onSubmit={handleAddStoreSubmit}>
              <div className="add-store-form__header">
                <h3>Add Store</h3>
                <div className="add-store-form__actions">
                  <button type="submit">
                    {isAddingStore ? 'Add Store' : 'Adding...'}
                  </button>
                  <button type="button" onClick={() => setIsAddingStore(false)}>
                    Cancel
                  </button>
                </div>
              </div>
              <div className="add-store-form__fields">
                <div className="add-store-form__field">
                  <label htmlFor="storeNumber">
                    <span className="add-store-form__field--required">*</span>Store Number</label>
                  <input
                    type="text"
                    id="storeNumber"
                    name="number"
                    value={newStore.number}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="add-store-form__field">
                  <label htmlFor="storeName">
                    <span className="add-store-form__field--required">*</span>
                    Store Name
                  </label>
                  <input
                    type="text"
                    id="storeName"
                    name="name"
                    value={newStore.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="add-store-form__field">
                  <label htmlFor="storeAddress"><span className="add-store-form__field--required">*</span>Store Address</label>
                  <input
                    type="text"
                    id="storeAddress"
                    name="address"
                    value={newStore.address}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};
